import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js"
import { Doughnut } from "react-chartjs-2"
import { colors } from "../../lib/colors"
import type { ChartData } from "../../types/analytics"

ChartJS.register(ArcElement, Tooltip, Legend)

const DEFAULT_COLORS = [colors.primary, colors.chartSecondary, colors.chartTertiary, colors.gray400]

interface DonutChartProps {
  data: ChartData
  colors?: string[]
}

const DonutChart = ({ data, colors = DEFAULT_COLORS }: DonutChartProps) => {
  const chartData = {
    labels: data.labels,
    datasets: data.datasets.map(ds => ({
      ...ds,
      backgroundColor: ds.backgroundColor ?? colors,
      borderWidth:     2,
      borderColor:     "#fff",
    })),
  }

  return (
    <Doughnut
      data={chartData}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "right" as const,
            labels: { font: { size: 12 }, padding: 12, boxWidth: 12 },
          },
        },
        cutout: "65%",
      }}
    />
  )
}

export default DonutChart
